import { Link } from 'react-router-dom';
import { Blueprint } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

/**
 * O cadastro público fechado (E166.F2.T03, produção e homologação): quem chega à tela de cadastro
 * por um link antigo vê de quem pedir o acesso — o administrador do escritório ou o gestor do banco.
 */
export function CadastroFechado() {
  return (
    <Blueprint
      as="section"
      data-testid="signup-fechado"
      aria-labelledby="signup-fechado-title"
      className="bg-bg px-8 py-[34px]"
    >
      <p className="mb-2.5 font-titulo text-rotulo uppercase text-fg-dim">
        {ptBR.authShell.accessKicker}
      </p>
      <h1 id="signup-fechado-title" className="font-display text-[32px] leading-none text-fg">
        {ptBR.signup.closedTitle}
      </h1>
      <p className="mt-3 text-body-sm text-fg-muted">{ptBR.signup.closedBody}</p>
      <div className="mt-[26px] border-t border-border pt-4 text-[12.5px] text-fg-dim">
        {ptBR.signup.hasAccount}{' '}
        <Link
          to="/login"
          className="text-accent-700 underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-accent"
        >
          {ptBR.signup.loginCta}
        </Link>
      </div>
    </Blueprint>
  );
}
